import { render, staticRenderFns } from "./subjectAnswer.vue?vue&type=template&id=b17e7fa8&scoped=true"
import script from "./subjectAnswer.vue?vue&type=script&lang=js"
export * from "./subjectAnswer.vue?vue&type=script&lang=js"
import style0 from "./subjectAnswer.vue?vue&type=style&index=0&id=b17e7fa8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17e7fa8",
  null
  
)

export default component.exports